// extracted by mini-css-extract-plugin
export var editButtonTitle = "partenaires-module--edit-button-title--aea8d";
export var listPartenairesContainer = "partenaires-module--list-partenaires-container--52c2a";
export var partenaireDescription = "partenaires-module--partenaire-description--17ea2";
export var partenaireItemDescription = "partenaires-module--partenaire-item-description--c41d7";
export var partenairesContainer = "partenaires-module--partenaires-container--8a1cf";
export var partenairesTitle = "partenaires-module--partenaires-title--fe933";